import { RouterSelectors } from '@next/core-lib/router-store';
import { createSelector, createFeatureSelector } from '@ngrx/store';

import { CropAid } from '../models/proprietary-fertilizer.model';
import { ProprietaryFertilizerState } from '../models/proprietary-fertilizer.state.model';

export const selectProprietaryFertilizerState =
  createFeatureSelector<ProprietaryFertilizerState>('proprietaryFertilizer');

export const selectOriginalCropAids = createSelector(
  selectProprietaryFertilizerState,
  (state) => state?.originalCropAids ?? [],
);

export const selectActiveOriginalFertilizers = createSelector(
  selectOriginalCropAids,
  (cropAids) =>
    cropAids
      ?.filter((c) => c.isActive && c.isFertilizer)
      ?.sort((a, b) => a.name.localeCompare(b.name)) ?? [],
);

export const selectProprietaryFertilizers = createSelector(
  selectProprietaryFertilizerState,
  (state) => state?.proprietaryFertilizers ?? [],
);

export const selectProprietaryFertilizer = createSelector(
  selectProprietaryFertilizers,
  (
    proprietaryFertilizers: CropAid[],
    { proprietaryFertilizerId }: { proprietaryFertilizerId: number },
  ) => proprietaryFertilizers.find(({ id }) => id === proprietaryFertilizerId),
);

export const selectEditingProprietaryFertilizer = createSelector(
  selectProprietaryFertilizers,
  RouterSelectors.getRouteParam('proprietaryFertilizerId'),
  (proprietaryFertilizers, proprietaryFertilizerId) =>
    selectProprietaryFertilizer.projector(proprietaryFertilizers, {
      proprietaryFertilizerId: parseInt(proprietaryFertilizerId, 10),
    }),
);
